import { useDataValue } from 'Simple/Data.js'

export default function useDataConfiguration(props) {
  let appointment_id = useDataValue({
    context: 'event',
    path: 'appointment._id',
    viewPath: props.viewPath,
  })

  return {
    variables: { appointment_id },
    pause: !appointment_id,
  }
}
